import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';

require('../hushcms/js/redactor/redactor.min.js');
require('../hushcms/js/redactor/counter.min.js');
require('../hushcms/js/redactor/table.min.js');
require('../hushcms/js/redactor/video.min.js');
require('../hushcms/js/redactor/imagemanager.js');
require('../hushcms/js/redactor/filemanager.js');
require('../hushcms/js/redactor/alignment.min.js');
require('../hushcms/js/redactor/button.js');

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
	// Require components after DOM is ready
	require('./vendor/jquery.hoverIntent');
	require('jquery-confirm');
	require('./cookie.js');
	require('./components/role-switcher');
});

// Datepicker
window.addEventListener('load', function () {
	const datetimePickers = document.querySelectorAll('.frontend-datetimepicker');
	const datePickers = document.querySelectorAll('.frontend-datepicker');

	function parseDate(dateString) {
		if (!dateString) return null;
		const [day, month, year] = dateString.split("/").map(Number);
		return new Date(year, month - 1, day);
	}

	function initializeDatepicker(picker, { minDate = null } = {}) {
		const startDate = parseDate(picker.getAttribute('data-startdate'));
		const setMinDate = parseDate(picker.getAttribute('data-setmindate'));

		const front_dtp = new AirDatepicker(picker, {
			locale: localeEn,
			dateFormat: 'dd/MM/yyyy',
			clearButton: true,
			todayButton: new Date(),
			minDate: minDate || setMinDate,
			autoClose: false,
			keyboardNav: true
		});

		if (startDate) {
			front_dtp.selectDate(startDate);
		} else {
			front_dtp.selectDate(minDate || setMinDate);
		}
	}

	datePickers.forEach(picker => initializeDatepicker(picker));

	datetimePickers.forEach(picker => {
		const minDate = parseDate(picker.getAttribute('data-setmindate'));
		initializeDatepicker(picker, { minDate });
	});
});

jQuery(document).ready(function ($) {

	$(document).on('click', '.help-icon', function (e) {
		e.preventDefault();
		$(this).toggleClass('is-open');
	});
	$(document).on('click', function (e) {
		if (!$(e.target).closest('.help-icon').length) {
			$('.help-icon.is-open').removeClass('is-open');
		}
	});

$(".select_all input").on('change', function () {
		var what = $(this).data('select-all');

		$("input[name='"+what+"[]']").not(this).prop('checked', this.checked);

	});

	$('#business_sector_select_all').click(function(event) {
	    if(this.checked) {
	        $('input[name="business_sector[]"]').each(function() {
	            this.checked = true;
	        });
	    } else {
	        $('input[name="business_sector[]"]').each(function() {
	            this.checked = false;
	        });
	    }
	});

	$('input[name="business_sector[]"]').click(function(event) {
		$('#business_sector_select_all').prop('checked', true);
        $('input[name="business_sector[]"]').each(function() {
        	if(!this.checked) {
            	$('#business_sector_select_all').prop('checked', false);
           	}
        });
	});

	if ( $('select.conditional_input').length ) {

		$( "select.conditional_input" ).change(function() {
			conditional_select(this);
		});

		conditional_select();

	}

	function conditional_select($element){

		if($element == undefined){
			$element = $('select.conditional_input');
		}

		var inputChange = $($element).data('input').split(",");
		var inputCheck = $($element).data('condition');
		var preselect = $($element).data('preselect');

        for(var i = 0; i < inputChange.length; i++){

        	var inputs = $( "select[name='"+ inputChange[i] +"'], input[name='"+ inputChange[i] +"']" );

	       	inputs.closest('div').hide();

			var selectOption = $($element).find('option:selected').val();
			if(selectOption == inputCheck){
				inputs.closest('div').show();
			}else{
				inputs.closest('div').hide();
				$( "select[name='"+ inputChange[i] +"']").val(preselect);
				$( "input[name='"+ inputChange[i] +"']").prop('checked', false);
				$( "input[name='"+ inputChange[i].replace("[]", "") +"']").val('');

			}

        }
	}

	if ( $('select.town_free_type_check').length ) {

		$( "select.town_free_type_check" ).change(function() {
			free_type_town_change(this);
		});

		free_type_town_change();

	}

	function free_type_town_change($element){

		if($element == undefined){
			$element = $('select.town_free_type_check');
		}

		var freeTypes = $($element).data('freetype');
		var selected = parseInt($($element).find('option:selected').val());

		if( freeTypes.includes(selected) ){
			$('.free_type_town[data-freetype="' + selected + '"]').show();
		}else{
			$('.free_type_town').hide()
		}

	}

	// Auth Form Switcher
	if ( $('.auth__switcher').length ) {
		$('.auth__switcher li').click(function(){
			$('.auth__switcher li.selected').removeClass("selected");
			$(this).addClass("selected");
            var form = $(this).attr("data-form");
            var form_class = '.' + form;
			$('.role_field').hide();
			$(form_class).show();

			$('input[name="role_type"]').val(form);

		});
		var role = $('input[name="role_type"]').val();
		$('.auth__switcher li[data-form="' + role + '"]').trigger('click');
	}

	//add required labels
	$('form :required').prev('label').addClass('required');
	$('form select:required').parent().prev('label').addClass('required');

	// Message Reply
	$('.request__messages__block__tools .reply').click(function(){
		$(this).parent().siblings('.request__messages__block__reply').slideToggle(400);
	});

	// Confirm
    jconfirm.defaults = {
        draggable: false,
        useBootstrap: false,
        boxWidth: '50rem',
        type: 'primary',
        typeAnimated: false
    };

	$('#save_attendees').on("click", function (e) {
		e.preventDefault();
		var form = $(this).closest('form');
        $.alert({
            title: 'Great!',
            content: 'By selecting attendees you will close the request and users will no longer be able to view and respond to your event (we advise contacting attendees by email to confirm attendance and coming back to select attendees when you have enough responses or approximately one week before the event).',
            buttons: {
                Cancel: {
                    text: 'Cancel',
                    action: function () {

                    }
                },
                OK: {
                    text: 'Continue',
                    btnClass: 'btn-primary',
                    action: function () {
						form.submit();
                    }
                }
            }
        });
	});
	
	$('.wysiwyg').redactor({
		linkNewTab: true, // show "open in new tab" in link popup
		linkNoFollow: false, // show "Set relation to "nofollow"" in link popup
		linkButtonStyle: false, // show "Display as button" in link popup
		pastePlainText: true,
		pasteImages: false, // prevent pasting images
		toolbar: true,
		buttons: ['bold', 'ol', 'ul', 'indent', 'outdent', 'link'],
		minHeight: '300px'
	});
});
